import { List, Map } from "immutable"

export const formatSizeChartData = (sizeCharts, pomData=Map()) => {
  return sizeCharts.get("tables", Map()).reduce(
    (tables, value, key) => tables.push(Map({ table: value, title: key, pomData })),
    List(),
  )
}
